import {useCallback, useEffect} from 'react';

const useKeyListener = (
    keys: string[],
    functionToCall: () => void,
    keyEventType: 'keydown' | 'keyup' | 'keypress' = 'keydown',
) => {
    const onUserKeyEvent = useCallback(
        (event: KeyboardEvent) => {
            if (keys.includes(event.key)) {
                functionToCall();
            }
        },
        [functionToCall, keys],
    );
    useEffect(() => {
        window.addEventListener(keyEventType, onUserKeyEvent);

        return () => {
            window.removeEventListener(keyEventType, onUserKeyEvent);
        };
    }, [keyEventType, onUserKeyEvent]);
};
export default useKeyListener;
